import { StyleSheet } from 'react-native'
import { Colors, Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes'

export default StyleSheet.create({
  titleStyle: theme => ({
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 25,
    color: theme.colors.headerTitleColor,
    paddingTop: 31.4,
    paddingBottom: 8,
    lineHeight: 31.2,
    ...Fonts.type.bold,
  }),
  subTitleStyle: theme => ({
    fontFamily: Fonts.type.VodafoneLt,
    fontSize: 16,
    color: theme.colors.headerTitleColor,
    paddingBottom: 26,
    lineHeight: 31.2,
  }),
  cardStyle: theme => ({
    backgroundColor: theme.colors.cardBackgroundColor,
    borderRadius: 6,
    shadowColor: Colors.linegrey,
    elevation: 2,
    shadowOffset: {
      width: 0,
      height: 2
    },
    shadowRadius: 4,
    shadowOpacity: 1
  }),
  cardContentStyle: {
    paddingHorizontal: 15,
    paddingVertical: 15
  },
  containerStyle: withTray => ({
    paddingHorizontal: 20,
    paddingBottom: 20,
  }),
  calendarStyle: {
    paddingBottom: 20
  },
  textStyle: theme => ({
    fontSize: 18.7,
    color: theme.colors.headerTitleColor,
    textAlign: 'center',
    paddingBottom: 2
  }),
  selectedDateTextStyle: theme => ({
    fontSize: 18.7,
    color: theme.colors.headerTitleColor,
    textAlign: 'center',
    marginBottom: 10.9,
    ...Fonts.type.bold
  }),
  timeSlotsContainerStyle: {
    marginHorizontal: -7,
    marginVertical: 9,
    flexDirection: 'row',
    flexWrap: 'wrap'
  },
  timeSlotContainerStyle: {
    width: '33%',
    paddingLeft: 8,
    paddingVertical: 7
  },
  timeSlotStyle: (isSelected, theme) => ({
    borderRadius: 6.2,
    borderColor: isSelected ? theme.colors.activeTabColor : Colors.brownGrey,
    fontWeight: isSelected ? 'bold' : 'normal',
    borderWidth: 1,
    fontSize: 14.6,
    lineHeight: 18.7,
    color: theme.colors.headerTitleColor,
    textAlign: 'center',
    paddingVertical: 5
  }),
  timeSlotsContainerLoadingStyle: {
    marginHorizontal: -7,
    flexDirection: 'row',
    flexWrap: 'wrap'
  },
  timeSlotContainerLoadingStyle: {
    width: '33%',
    paddingLeft: 8,
    paddingVertical: 7
  },
  timeSlotLoadingStyle: theme => ({
    borderRadius: 6.2,
    borderColor: theme.colors.shimmerBorder,
    borderWidth: 1,
    color: theme.colors.headerTitleColor,
    paddingVertical: 5,
    height: 30,
  }),
  dividerStyle: theme => ({
    width: '100%',
    backgroundColor: theme.colors.VFDivider.tertiary,
    height: 1,
    marginBottom: 17,
  }),
  calendarSelectedDateTextStyle: theme => {
    return ({
      color: theme.colors.cardBackgroundColor,
    })
  },
  calendarArrowStyle: direction => ({
    marginRight: direction === 'right' ? -15 : 0,
    marginLeft: direction === 'left' ? -15 : 0
  }),
  disabledButtonStyle: theme => ({
    backgroundColor: theme.colors.buttons.disabledThree
  }),
  disabledButtonTextStyle: theme => ({
    color: theme.colors.textButtons.disabled
  }),
  calendarBackgroundStyle: theme => ({
    color: theme.colors.cardBackgroundColor
  }),
  monthTitleStyle: theme => ({
    color: theme.colors.textColorFive,
    fontFamily: Fonts.type.VFFont,
    fontSize: 18.7
  }),
  dayNamesStyles: theme => ({
    color: theme.colors.textColorSix,
    fontFamily: Fonts.type.VFFont,
    fontSize: 14.6
  }),
  daysNumbersStyles: theme => ({
    color: theme.colors.textColorFive,
    // fontFamily: Fonts.type.VFFont,
    fontSize: 14.6,
    alignSelf: 'center'
  }),
  disabledDaysNumbersStyles: {
    color: Colors.platinum
  }
})
